"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockWaterbodyTemperature = void 0;
function mockWaterbodyTemperature(overrides = {}) {
    return {
        site_id: 'mock_site_id',
        water_temp: 'mock_water_temp',
        temp_graph: [],
        thermals: [],
        ...overrides,
    };
}
exports.mockWaterbodyTemperature = mockWaterbodyTemperature;
